<div class="center">
  <span *ngIf="files.length==0 || resetFile">
    <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)"
      (onFileLeave)="fileLeave($event)">
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        <div class="dropBox row">
          <div class="column upload-file" (click)="openFileSelector()">
            <span class="material-icons">cloud_upload</span>
            <div class="light-text">Upload Parameters</div>
          </div>
        </div>
      </ng-template>
    </ngx-file-drop>
  </span>
  <ng-template downloadBtn></ng-template>
  <span *ngIf="files.length!=0 && !resetFile" class="outer-border ">
    <div> File Name : {{files[0].relativePath}}</div>
    <div class="btns">
      <button mat-raised-button (click)="reset()" class="reset-btn">Reset</button>
    </div>
  </span>
</div>